(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/suspension-message/helpers/handlebar-helper.js') >= 0) return;  svs.modules.push('/components/components/suspension-message/helpers/handlebar-helper.js'); 
'use strict';

if (typeof exports === 'object') {
  registerHelpers(require('hbs'));
} else {
  registerHelpers(Handlebars);
}

function registerHelpers(hbs) {
  hbs.registerHelper('getProductName', function(product, capitalize) {
    var productName = '';
    switch (product) {
      case 'all':
        productName = capitalize ? 'Alla spel' : 'alla spel';
        break;
      case 'poker':
        productName = 'Poker';
        break;
      case 'vegas':
        productName = 'Vegas';
        break;
      case 'quickGames':
        productName = 'Spelpaus24';
        break;
      default:
        productName = 'aktiv';
    }
    return productName;
  });

  hbs.registerHelper('getSuspensionPeriod', function(suspension) {
    var period =
      suspension.period > 0
        ? suspension.period
        : suspension.terminationPeriod || 0;
    if (period === 0) {
      return '';
    } else if (period < 12) {
      return period + ' månader';
    }
    return period / 12 + ' år';

  });
  hbs.registerHelper('anyActive', function(suspensions, options) {
    var anyActive = suspensions.filter(function(suspension) {
      return !suspension.isTerminable;
    });

    if (anyActive.length > 0) {
      return options.fn(this);
    }
    return options.inverse(this);

  });
  hbs.registerHelper('anyTerminable', function(suspensions, options) {
    var anyTerminable = suspensions.filter(function(suspension) {
      return suspension.isTerminable;
    });

    if (anyTerminable.length > 0) {
      return options.fn(this);
    }
    return options.inverse(this);

  });
}


 })(window);